// Mirrors NiceUrlService::LOCATIONS in Ruby. Region names match User::REGIONS.
export const LOCATIONS = [
  { region: 'Hlavní město Praha',   regionSlug: 'hlavni-mesto-praha',   districts: [
      { name: 'Praha',              slug: 'hlavni-mesto-praha' }
    ]},
  { region: 'Středočeský kraj',     regionSlug: 'stredocesky-kraj',     districts: [
      { name: 'Benešov',            slug: 'benesov' },
      { name: 'Beroun',             slug: 'beroun' },
      { name: 'Kladno',             slug: 'kladno' },
      { name: 'Kolín',              slug: 'kolin' },
      { name: 'Kutná Hora',         slug: 'kutna-hora' },
      { name: 'Mělník',             slug: 'melnik' },
      { name: 'Mladá Boleslav',     slug: 'mlada-boleslav' },
      { name: 'Nymburk',            slug: 'nymburk' },
      { name: 'Praha-východ',       slug: 'praha-vychod' },
      { name: 'Praha-západ',        slug: 'praha-zapad' },
      { name: 'Příbram',            slug: 'pribram' },
      { name: 'Rakovník',           slug: 'rakovnik' }
    ]},
  { region: 'Jihočeský kraj',       regionSlug: 'jihocesky-kraj',       districts: [
      { name: 'České Budějovice',   slug: 'ceske-budejovice' },
      { name: 'Český Krumlov',      slug: 'cesky-krumlov' },
      { name: 'Jindřichův Hradec',  slug: 'jindrichuv-hradec' },
      { name: 'Písek',              slug: 'pisek' },
      { name: 'Prachatice',         slug: 'prachatice' },
      { name: 'Strakonice',         slug: 'strakonice' },
      { name: 'Tábor',              slug: 'tabor' }
    ]},
  { region: 'Plzeňský kraj',        regionSlug: 'plzensky-kraj',        districts: [
      { name: 'Domažlice',          slug: 'domazlice' },
      { name: 'Klatovy',            slug: 'klatovy' },
      { name: 'Plzeň-město',        slug: 'plzen-mesto' },
      { name: 'Plzeň-jih',          slug: 'plzen-jih' },
      { name: 'Plzeň-sever',        slug: 'plzen-sever' },
      { name: 'Rokycany',           slug: 'rokycany' },
      { name: 'Tachov',             slug: 'tachov' }
    ]},
  { region: 'Karlovarský kraj',     regionSlug: 'karlovarsky-kraj',     districts: [
      { name: 'Cheb',               slug: 'cheb' },
      { name: 'Karlovy Vary',       slug: 'karlovy-vary' },
      { name: 'Sokolov',            slug: 'sokolov' }
    ]},
  { region: 'Ústecký kraj',         regionSlug: 'ustecky-kraj',         districts: [
      { name: 'Děčín',              slug: 'decin' },
      { name: 'Chomutov',           slug: 'chomutov' },
      { name: 'Litoměřice',         slug: 'litomerice' },
      { name: 'Louny',              slug: 'louny' },
      { name: 'Most',               slug: 'most' },
      { name: 'Teplice',            slug: 'teplice' },
      { name: 'Ústí nad Labem',     slug: 'usti-nad-labem' }
    ]},
  { region: 'Liberecký kraj',       regionSlug: 'liberecky-kraj',       districts: [
      { name: 'Česká Lípa',         slug: 'ceska-lipa' },
      { name: 'Jablonec nad Nisou', slug: 'jablonec-nad-nisou' },
      { name: 'Liberec',            slug: 'liberec' },
      { name: 'Semily',             slug: 'semily' }
    ]},
  { region: 'Královehradecký kraj', regionSlug: 'kralovehradecky-kraj', districts: [
      { name: 'Hradec Králové',     slug: 'hradec-kralove' },
      { name: 'Jičín',              slug: 'jicin' },
      { name: 'Náchod',             slug: 'nachod' },
      { name: 'Rychnov nad Kněžnou',slug: 'rychnov-nad-kneznou' },
      { name: 'Trutnov',            slug: 'trutnov' }
    ]},
  { region: 'Pardubický kraj',      regionSlug: 'pardubicky-kraj',      districts: [
      { name: 'Chrudim',            slug: 'chrudim' },
      { name: 'Pardubice',          slug: 'pardubice' },
      { name: 'Svitavy',            slug: 'svitavy' },
      { name: 'Ústí nad Orlicí',    slug: 'usti-nad-orlici' }
    ]},
  { region: 'Vysočina',             regionSlug: 'vysocina',             districts: [
      { name: 'Havlíčkův Brod',     slug: 'havlickuv-brod' },
      { name: 'Jihlava',            slug: 'jihlava' },
      { name: 'Pelhřimov',          slug: 'pelhrimov' },
      { name: 'Třebíč',             slug: 'trebic' },
      { name: 'Žďár nad Sázavou',   slug: 'zdar-nad-sazavou' }
    ]},
  { region: 'Jihomoravský kraj',    regionSlug: 'jihomoravsky-kraj',    districts: [
      { name: 'Blansko',            slug: 'blansko' },
      { name: 'Brno-město',         slug: 'brno-mesto' },
      { name: 'Brno-venkov',        slug: 'brno-venkov' },
      { name: 'Břeclav',            slug: 'breclav' },
      { name: 'Hodonín',            slug: 'hodonin' },
      { name: 'Vyškov',             slug: 'vyskov' },
      { name: 'Znojmo',             slug: 'znojmo' }
    ]},
  { region: 'Olomoucký kraj',       regionSlug: 'olomoucky-kraj',       districts: [
      { name: 'Jeseník',            slug: 'jesenik' },
      { name: 'Olomouc',            slug: 'olomouc' },
      { name: 'Prostějov',          slug: 'prostejov' },
      { name: 'Přerov',             slug: 'prerov' },
      { name: 'Šumperk',            slug: 'sumperk' }
    ]},
  { region: 'Zlínský kraj',         regionSlug: 'zlinsky-kraj',         districts: [
      { name: 'Kroměříž',           slug: 'kromeriz' },
      { name: 'Uherské Hradiště',   slug: 'uherske-hradiste' },
      { name: 'Vsetín',             slug: 'vsetin' },
      { name: 'Zlín',               slug: 'zlin' }
    ]},
  { region: 'Moravskoslezský kraj', regionSlug: 'moravskoslezsky-kraj', districts: [
      { name: 'Bruntál',            slug: 'bruntal' },
      { name: 'Frýdek-Místek',      slug: 'frydek-mistek' },
      { name: 'Karviná',            slug: 'karvina' },
      { name: 'Nový Jičín',         slug: 'novy-jicin' },
      { name: 'Opava',              slug: 'opava' },
      { name: 'Ostrava-město',      slug: 'ostrava-mesto' }
    ]}
]
